
import { useEffect } from 'react'
import { useUpdateNodeInternals, useReactFlow } from '@xyflow/react'
import { useZoomLOD } from '@/components/canvas/hooks/useZoomLOD'
import { useCanvasBridgeStore } from '@/stores/useCanvasBridgeStore'

/* ------------------------------------------------------------------ */
/*  Bridge exposers: register RF methods on the canvas bridge store    */
/* ------------------------------------------------------------------ */

/** Expose updateNodeInternals to bridge store for programmatic edge wiring */
export function NodeInternalsExposer() {
  const updateNodeInternals = useUpdateNodeInternals()
  useEffect(() => {
    useCanvasBridgeStore.getState().registerUpdateNodeInternals(updateNodeInternals)
    return () => { useCanvasBridgeStore.getState().registerUpdateNodeInternals(null) }
  }, [updateNodeInternals])
  return null
}

export function FitViewExposer() {
  const { fitView } = useReactFlow()
  useEffect(() => {
    const wrappedFitView = (nodeIds: string[]) => {
      fitView({
        nodes: nodeIds.map(id => ({ id })),
        duration: 400,
        padding: 0.3,
      })
    }
    useCanvasBridgeStore.getState().registerFitView(wrappedFitView)
    return () => { useCanvasBridgeStore.getState().registerFitView(null) }
  }, [fitView])
  return null
}

/* ------------------------------------------------------------------ */
/*  LOD Controller (sets data-lod attribute on .react-flow element)    */
/* ------------------------------------------------------------------ */

export function LODController() {
  const { tier } = useZoomLOD()

  useEffect(() => {
    const el = document.querySelector('.react-flow')
    if (el) {
      el.setAttribute('data-lod', tier)
    }
  }, [tier])

  return null
}
